import { Injectable } from '@angular/core';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { SalaryAccrualFindInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-find.dto';
import type { SalaryAccrualFormInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-form.dto';
import type { SalaryAccrualGroupFormInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-group-form.dto';
import type { SalaryAccrualRepeatFormInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-repeat-form.dto';
import type { SalaryAccrualBindDocumentsInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-bind-documents.dto';
import type { SalaryAccrualQueryInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-query.dto';
import type { SalaryAccrualPageInterface } from '@zaoblako/shared/modules/document/dtos/salary-accrual/salary-accrual-page.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { EntityCardHistoryQueryInterface } from '@zaoblako/shared/common/dtos/history/entity-card-history-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalaryAccrualService extends BaseService {
  protected baseUrl = '/finance/document/salary-accrual';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor(): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);
  }

  public findPage(queryParams?: SalaryAccrualQueryInterface): Observable<SalaryAccrualPageInterface> {
    return this.http.get<SalaryAccrualPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public createGroup(body: SalaryAccrualGroupFormInterface): Observable<SalaryAccrualPageInterface> {
    return this.http.post<SalaryAccrualPageInterface>(`${this.baseUrl}/group`, body);
  }

  public repeatOne(id: number, body: SalaryAccrualRepeatFormInterface): Observable<SalaryAccrualPageInterface> {
    return this.http.post<SalaryAccrualPageInterface>(`${this.baseUrl}/${id}/repeat`, body);
  }

  public bindDocuments(id: number, body: SalaryAccrualBindDocumentsInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/bind-documents`, body);
  }

  public getHistoryById(id: number, params: EntityCardHistoryQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(params)
    });
  }

  public override create<T = SalaryAccrualFindInterface>(model: SalaryAccrualFormInterface): Observable<T> {
    return super.create<T>(model);
  }
}
